export const filters = [
  {
    id: '0',
    label: 'Genre',
    options: [
      { id: '00', label: 'Homme' },
      { id: '01', label: 'Femme' },
      { id: '02', label: 'Autre' }
    ]
  },
  {
    id: '1',
    label: 'Âge',
    options: [
      { id: '10', label: '18-30 ans' },
      { id: '11', label: '30-45 ans' },
      { id: '12', label: '45-60 ans' },
      { id: '13', label: 'Plus de 60 ans' }
    ]
  },
  {
    id: '2',
    label: 'Profession',
    options: [
      { id: '20', label: 'agriculture' },
      { id: '21', label: 'mines' },
      { id: '22', label: 'industrie' },
      { id: '23', label: 'électricité, gaz, air conditionné' },
      { id: '24', label: 'eau, déchets' },
      { id: '25', label: 'construction, génie civil' },
      { id: '26', label: 'commerce' },
      { id: '27', label: 'transports, poste' },
      { id: '28', label: 'hébegement, restauration' },
      { id: '29', label: 'information, TV, radio, communication' },
      { id: '210', label: 'finance, banque, assurance' },
      { id: '211', label: 'immobilier' },
      {
        id: '212',
        label: 'activités spécialisées, scientifiques et techniques'
      },
      {
        id: '213',
        label: 'activités de services administratifs et de soutien'
      },
      { id: '214', label: 'administration publique' },
      { id: '215', label: 'enseignement' },
      { id: '216', label: 'santé, social' },
      { id: '217', label: 'culture, sports' },
      {
        id: '218',
        label: 'autres activités de services'
      },
      { id: '219', label: 'ménage employeur' },
      { id: '220', label: 'ambassade, organisation internationale' },
      { id: '221', label: 'retraité' },
      { id: '222', label: 'étudiant' },
      { id: '223', label: 'indépendant' },
      { id: '224', label: 'scientifique' },
      { id: '225', label: 'droit' },
      { id: '226', label: 'employé de commerce' },
      { id: '227', label: 'sécurité, police, secours' },
      { id: '228', label: 'ingénieur' },
      { id: '229', label: 'consultant' },
      { id: '230', label: 'environnement, nature' },
      { id: '231', label: 'parent au foyer' },
      { id: '232', label: 'sans dénomination' },
      { id: '233', label: 'entrepreneur' },
      { id: '234', label: 'autre' },
      { id: '235', label: 'informatique' }
    ]
  },
  {
    id: '4',
    label: 'Syndic',
    options: [
      { id: '40', label: 'Syndic' },
      { id: '41', label: 'Non syndic' }
    ]
  },
  {
    id: '5',
    label: 'Sortant',
    options: [
      { id: '50', label: 'Sortant' },
      { id: '51', label: 'Non sortant' }
    ]
  },
  {
    id: '6',
    label: "Secteur d'activité",
    options: [
      { id: '60', label: 'Primaire' },
      { id: '61', label: 'Secondaire' },
      { id: '62', label: 'Tertiaire' },
      { id: '63', label: 'Autre' }
    ]
  }
]

/* {
  id: '3',
  label: 'Orientation politique',
  options: [
    { id: '30', label: 'PLR' },
    { id: '31', label: 'UDC' },
    { id: '32', label: 'PS' },
    { id: '33', label: 'Les Verts' },
    { id: '34', label: 'Centre' },
    { id: '35', label: 'Autre gauche' },
    { id: '36', label: 'Autre droite' },
    { id: '37', label: 'Autre' },
    { id: '38', label: 'Indépendant' },
    { id: '39', label: 'Indépendant' },
    { id: '310', label: 'Entente' },
    { id: '311', label: 'Alliance PLR-UDC' },
    { id: '312', label: 'Alliance PS-Verts' },
    { id: '313', label: 'Autre alliance droite' },
    { id: '314', label: 'Autre alliance gauche' },
    { id: '315', label: 'Vertlibéraux' },
    { id: '316', label: 'Sans dénomination' },
    { id: '317', label: 'Autre alliance communale' },
    { id: '318', label: 'PS et autres' },
    { id: '319', label: 'PLR et autres' },
    { id: '320', label: 'Verts et autres' },
    { id: '321', label: 'UDC et autres' }
  ]
}, */
